export const BASE_URL = '/api'
export const EPP_MESSAGES = BASE_URL + '/eppMessages'
